import { CustomSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/types';
import {
    SLIDE_WIDTH,
    SLIDE_HEIGHT,
} from 'sections/welcomeAnim/costumeVariations/mediaCarousel/mediaCarouselConstants';
import {
    getDesktopSrc2x,
    getDesktopSrc3x,
    getDesktopSrcWebp,
    getDesktopSrcWebp2x,
    getDesktopSrcWebp3x,
} from 'utils/imageResize.utils';

export const createImageSlide = (
    jpegSrc: string,
    alt = 'set costumes'
): CustomSlide => {
    const webpImg = getDesktopSrcWebp(jpegSrc);

    return {
        type: 'image',
        src: jpegSrc,
        alt,
        width: SLIDE_WIDTH,
        height: SLIDE_HEIGHT,
        srcSet: [
            {
                src: webpImg,
                width: SLIDE_WIDTH,
                height: SLIDE_HEIGHT,
                descriptor: '1x',
                type: 'image/webp',
            },
            {
                src: getDesktopSrcWebp2x(webpImg),
                width: SLIDE_WIDTH * 2,
                height: SLIDE_HEIGHT * 2,
                descriptor: '2x',
                type: 'image/webp',
            },
            {
                src: getDesktopSrcWebp3x(webpImg),
                width: SLIDE_WIDTH * 3,
                height: SLIDE_HEIGHT * 3,
                descriptor: '3x',
                type: 'image/webp',
            },
            {
                src: jpegSrc,
                width: SLIDE_WIDTH,
                height: SLIDE_HEIGHT,
                descriptor: '1x',
                type: 'image/jpeg',
            },
            {
                src: getDesktopSrc2x(jpegSrc),
                width: SLIDE_WIDTH * 2,
                height: SLIDE_HEIGHT * 2,
                descriptor: '2x',
                type: 'image/jpeg',
            },
            {
                src: getDesktopSrc3x(jpegSrc),
                width: SLIDE_WIDTH * 3,
                height: SLIDE_HEIGHT * 3,
                descriptor: '3x',
                type: 'image/jpeg',
            },
        ],
    };
};

export const createVideoSlide = (
    mp4Src: string,
    poster = 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/3@1x.jpg'
): CustomSlide => {
    return {
        type: 'video',
        width: SLIDE_WIDTH,
        height: SLIDE_HEIGHT,
        poster,
        sources: [
            {
                src: mp4Src,
                type: 'video/mp4',
            },
        ],
    };
};
